<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row v-if="routeName === 'EXCMAgreementEdit'">
      <b-col sm="12" lg="auto">
        <div class="form-group">
          <label
            for="excmagreement_agreementNumber"
            class="form-control-label">{{$t('views.excmagreements.form.agreementNumber')}}:</label>
          <input
            id="excmagreement_agreementNumber"
            v-model="item.agreementNumber"
            :class="['form-control', isInvalid('agreementNumber') ? 'is-invalid' : '']"
            type="text"
            required="true"
            placeholder=""
            disabled="true"
            @input="handleUpdateField('agreementNumber', $event.target.value)">
          <div
            v-if="isInvalid('agreementNumber')"
            class="invalid-feedback">{{ violations.agreementNumber }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
                  for="excmconsent_agreementType"
                  class="form-control-label">{{$t('views.excmagreements.form.agreementType')}}:</label>
          <fg-input :error="violations.agreementType">
            <el-select
                    id="excmconsent_agreementType"
                    :class="['select-default', isInvalid('agreementType') ? 'select-danger' : '']"
                    :placeholder="$t('views.excmagreements.form.agreementType')"
                    filterable
                    v-model="item.agreementType">
              <el-option v-for="option in agreementTypeOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.title"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
                  v-if="isInvalid('itemType')"
                  class="invalid-feedback">{{ violations.agreementType }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="excmagreement_dateFrom"
            class="form-control-label">{{$t('views.excmagreements.form.dateFrom')}}:</label>
          <fg-input :error="violations.dateFrom">
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              v-model="item.dateFrom"
              type="date"
              default-time="12:00:00">
            </el-date-picker>
          </fg-input>
          <div
            v-if="isInvalid('dateFrom')"
            class="invalid-feedback">{{ violations.dateFrom }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label
            for="excmagreement_dateTo"
            class="form-control-label">{{$t('views.excmagreements.form.dateTo')}}:</label>
          <fg-input :error="violations.dateTo">
            <el-date-picker
              :picker-options="{firstDayOfWeek: 1}"
              v-model="item.dateTo"
              type="date"
              default-time="12:00:00">
            </el-date-picker>
          </fg-input>
          <div
            v-if="isInvalid('dateTo')"
            class="invalid-feedback">{{ violations.dateTo }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="6">
        <div class="form-group">
          <label
            for="excmagreement_company"
            class="form-control-label">{{$t('views.excmagreements.form.company')}}:</label>
          <fg-input :error="violations.company">
            <el-select
              id="excmagreement_company"
              :class="['select-default', isInvalid('company') ? 'select-danger' : '']"
              :placeholder="$t('views.excmagreements.form.company')"
              filterable
              v-model="item.company">
              <el-option v-for="option in companyOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.firmname1"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
            v-if="isInvalid('company')"
            class="invalid-feedback">{{ violations.company }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="6">
        <div class="form-group">
          <label
                  for="excmagreement_contactPerson"
                  class="form-control-label">{{$t('views.excmagreements.form.contactPerson')}} ({{ contactPersonOptions.length }}):</label>
          <fg-input :error="violations.contactPerson">
            <el-select
                    id="excmagreement_contactPerson"
                    :class="['select-default', isInvalid('contactPerson') ? 'select-danger' : '']"
                    :placeholder="$t('views.excmagreements.form.contactPerson')"
                    filterable
                    v-model="item.contactPerson">
              <el-option v-for="option in contactPersonOptions"
                         class="select-default"
                         :value="option.employee['@id']"
                         :label="option.employee.name + ' ' + option.employee.surname"
                         :key="option.employee['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
                  v-if="isInvalid('company')"
                  class="invalid-feedback">{{ violations.contactPerson }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="(routeName === 'EXCMAgreementCreate' || this.openedInCreateModal) && devicesOptions.length > 0">
      <b-col cols="12">
        <b-row v-for="(agreementDevice, index) in item.agreementDevices" :index="index" v-bind:key="'agreementDevice-' + index" class="mb-2">
          <b-col>
            <b-row>
              <b-col cols="12" lg="1">
                <h5 class="pt-1 text-center">#{{ index + 1 }}</h5>
              </b-col>
              <b-col cols="10" lg="10">
                <div class="form-group">
                  <fg-input>
                    <el-select
                      id="exsbbatchnumber_invoiceType"
                      class="select-default"
                      :placeholder="$t('views.excmagreements.form.device')"
                      filterable
                      v-model="item.agreementDevices[index].device">
                      <el-option v-for="option in devicesOptions"
                                 class="select-default"
                                 :value="option['@id']"
                                 :label="option.idDeviceModel.idDeviceType.title + ' ' + option.idDeviceModel.idDeviceBrand.brandTitle + ' (' + option.serialNumber + ')'"
                                 :key="option['@id']">
                      </el-option>
                    </el-select>
                  </fg-input>
                </div>
              </b-col>
              <b-col cols="2" lg="1">
                <b-btn class="btn btn-danger mt-0 float-right" @click="removeAgreementDevice(index)">
                  <span v-if="!mobileView">{{ $t('buttons.delete') }}</span>
                  <i v-else class="far fa-trash-alt"></i>
                </b-btn>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="1"></b-col>
              <b-col>
                <b-form-checkbox
                  :id="'isDeviceAddressBasedOnAgreement-' + index"
                  v-model="agreementDevice.isDeviceAddressBasedOnAgreement"
                  name="checkbox-1"
                  value="1"
                  unchecked-value="0"
                >
                  {{ $t('views.excmagreements.form.isDeviceAddressBasedOnAgreement') }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-btn class="btn btn-success" @click="addAgreementDevice()">{{ $t('views.excmagreements.form.addAgreementDevice') }}</b-btn>
            <button type="button" class="btn btn-default" @click="toggleCreateDeviceModal()">{{$t('buttons.addNewDevice')}}</button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="(routeName === 'EXCMAgreementCreate' || this.openedInCreateModal) && slasOptions.length > 0">
      <b-col cols="12">
        <b-row v-for="(agreementSla, index) in item.agreementSlas" :index="index" v-bind:key="'agreementSla-' + index">
          <b-col cols="12" lg="1">
            <h5 class="pt-1 text-center">#{{ index + 1 }}</h5>
          </b-col>
          <b-col cols="10">
            <div class="form-group">
              <fg-input>
                <el-select
                        class="select-default"
                        :placeholder="$t('views.excmagreements.form.sla')"
                        filterable
                        v-model="item.agreementSlas[index].sla">
                  <el-option v-for="option in slasOptions"
                             class="select-default"
                             :value="option['@id']"
                             :label="option.title"
                             :key="option['@id']">
                  </el-option>
                </el-select>
              </fg-input>
            </div>
          </b-col>
          <b-col cols="2" lg="1">
            <b-btn class="btn btn-danger mt-0 float-right" @click="removeAgreementSla(index)">
              <span v-if="!mobileView">{{ $t('buttons.delete') }}</span>
              <i v-else class="far fa-trash-alt"></i>
            </b-btn>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-btn class="btn btn-success" @click="addAgreementSla()">{{ $t('views.excmagreements.form.addAgreementSla') }}</b-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="(routeName === 'EXCMAgreementCreate' || openedInCreateModal) && consentsOptions.length > 0">
      <b-col cols="12">
        <b-row v-for="(consent, index) in consentsOptions" :index="index" v-bind:key="'consent-' + index">
          <b-col>
            <b-form-checkbox
                    :id="'consentCheckbox-' + index"
                    v-model="item.agreementConsents[index].agree"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0"
            >
              {{ consent.title }} <b v-if="consent.requireConsent === 1">({{$t('global.requiredLowercase')}})</b>
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="routeName === 'EXCMAgreementCreate' || this.openedInCreateModal">
      <b-col cols="12">
        <template v-for="(agreementCyclicTask, agreementCyclicTaskIndex) in item.agreementCyclicTasks">
          <AgreementCyclicTaskRow :agreementCyclicTask="agreementCyclicTask"
                                  :taskTypeOptions="taskTypeOptions"
                                  :caseGenresOptions="caseGenresOptions"
                                  :caseTypesOptions="caseTypesOptions"
                                  :removeAgreementCyclicTask="removeAgreementCyclicTask"
                                  v-bind:key="'agreementCyclicTask-' + agreementCyclicTaskIndex"
                                  :index="agreementCyclicTaskIndex"></AgreementCyclicTaskRow>
        </template>
      </b-col>
      <b-col cols="12">
        <b-btn class="btn btn-success" @click="addAgreementCyclicTask()">{{ $t('views.excmagreements.form.addAgreementCyclicTask') }}</b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
        <b-btn variant="danger" @click="cancel()">{{ $t('buttons.cancel') }}</b-btn>
      </b-col>
    </b-row>
    <create-device-modal v-if="!openedInCreateModal"></create-device-modal>
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import getId from '@/utils/getIdFromLink'
import AgreementCyclicTaskRow from './components/AgreementCyclicTaskRow'
import addParamsToQuery from '@/utils/addParamsToQuery'
import ApiService from '@/utils/ApiService'
import createDeviceModal from '@/components/Dashboard/Views/excmdevice/modals/CreateModal'

export default {
  components: {
    AgreementCyclicTaskRow,
    createDeviceModal
  },

  props: {
    openedInCreateModal: {
      type: Boolean,
      default: false
    },
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters({
      contactPersonOptions: 'userdataemployee/list/items',
      agreementTypeOptions: 'excmagreementtype/list/items',
      taskTypeOptions: 'excmtasktype/list/items',
      caseTypesOptions: 'excmcasetype/list/items',
      devicesOptions: 'excmdevice/list/items',
      slasOptions: 'excmsla/list/items'
    }),
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    mobileView () {
      return this.$store.state.mobileView
    },

    violations () {
      return this.errors || {}
    }
  },

  watch: {
    item: function (itemUpdate) {
      this.unwatchCompany()
      if (itemUpdate.contactPerson && itemUpdate.contactPerson['@id']) {
        itemUpdate.contactPerson = itemUpdate.contactPerson['@id']
      } else {
        itemUpdate.contactPerson = null
      }
      if (itemUpdate.company && itemUpdate.company['@id']) {
        itemUpdate.company = itemUpdate.company['@id']
      } else {
        itemUpdate.company = null
      }
      this.getContactPersons()
      this.createCompanyWatcher()
    },
    'item.agreementType': function (val) {
      this.getConsents()
    }
  },

  data () {
    return {
      routeName: '',
      companyOptions: [],
      consentsOptions: [],
      caseGenresOptions: []
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  created () {
    this.routeName = this.$route.name
    this.getCompanies()
    this.channelCompanies = this.$store.state.Pusher.subscribe('user_datas')
    this.channelCompanies.bind('user_datas', data => {
      this.getCompanies()
    })
    this.routeName = this.$route.name
    this.channelContactPersons = this.$store.state.Pusher.subscribe('user_datas')
    this.channelContactPersons.bind('user_datas', data => {
      this.getContactPersons()
    })
    this.getEXCMAgreementTypes()
    this.channelEXCMAgreementTypes = this.$store.state.Pusher.subscribe('e_x_c_m_agreement_types')
    this.channelEXCMAgreementTypes.bind('e_x_c_m_agreement_types', data => {
      this.getEXCMAgreementTypes()
    })
    this.getEXCMTaskTypes()
    this.channelEXCMTaskTypes = this.$store.state.Pusher.subscribe('e_x_c_m_task_types')
    this.channelEXCMTaskTypes.bind('e_x_c_m_task_types', data => {
      this.getEXCMTaskTypes()
    })
    if (this.routeName === 'EXCMAgreementCreate' || this.openedInCreateModal) {
      this.getDevices()
      this.channelDevices = this.$store.state.Pusher.subscribe('e_x_c_m_devices')
      this.channelDevices.bind('e_x_c_m_devices', data => {
        this.getDevices()
      })
      this.channelContents = this.$store.state.Pusher.subscribe('e_x_c_m_consents')
      this.channelContents.bind('e_x_c_m_consents', data => {
        this.getConsents()
      })
      this.getSlas()
      this.channelSlas = this.$store.state.Pusher.subscribe('e_x_c_m_slas')
      this.channelSlas.bind('e_x_c_m_slas', data => {
        this.getSlas()
      })
      this.getCaseGenres()
      this.channelCaseGenres = this.$store.state.Pusher.subscribe('e_x_c_m_case_genres')
      this.channelCaseGenres.bind('e_x_c_m_case_genres', data => {
        this.getCaseGenres()
      })
      this.getCaseTypes()
      this.channelCaseTypes = this.$store.state.Pusher.subscribe('e_x_c_m_case_types')
      this.channelCaseTypes.bind('e_x_c_m_case_types', data => {
        this.getCaseTypes()
      })
    }
    this.createCompanyWatcher()
  },

  destroyed () {
    if (this.routeName === 'EXCMAgreementCreate' || this.openedInCreateModal) {
      this.$store.state.Pusher.unsubscribe('e_x_c_m_devices')
      this.$store.state.Pusher.unsubscribe('e_x_c_m_consents')
    }
    this.$store.state.Pusher.unsubscribe('user_datas')
    this.$store.state.Pusher.unsubscribe('e_x_c_m_slas')
    this.$store.state.Pusher.unsubscribe('e_x_c_m_case_genres')
    this.$store.state.Pusher.unsubscribe('e_x_c_m_task_types')
    this.$store.state.Pusher.unsubscribe('e_x_c_m_agreement_types')
    this.$store.state.Pusher.unsubscribe('e_x_c_m_case_types')
  },

  methods: {
    ...mapActions({
      fetchUserDataEmployees: 'userdataemployee/list/default',
      fetchAgreementTypes: 'excmagreementtype/list/default',
      fetchTaskTypes: 'excmtasktype/list/getItems',
      fetchCaseTypes: 'excmcasetype/list/default',
      fetchDevices: 'excmdevice/list/default',
      fetchSlas: 'excmsla/list/default'
    }),
    ...mapMutations({
      toggleCreateDeviceModal: 'excmdevice/createModal/toggleModal'
    }),
    addAgreementCyclicTask () {
      let item = {
        caseType: null,
        taskType: null,
        caseGenre: null,
        daysInterval: 0,
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      }
      this.item.agreementCyclicTasks.push(item)
    },
    cancel () {
      if (this.routeName === 'EXCMAgreementShow') {
        this.$store.state.modals.excmagreement.update.close = 1
      } else {
        this.$router.push({ name: 'EXCMAgreementList' })
      }
    },
    createCompanyWatcher () {
      this.unwatchCompany = this.$watch(
        function () {
          return this.item.company
        },
        function (newValue) {
          this.item.contactPerson = null
          this.getContactPersons()
        }
      )
    },
    removeAgreementCyclicTask (index) {
      this.item.agreementCyclicTasks.splice(index, 1)
    },
    removeAgreementDevice (index) {
      this.item.agreementDevices.splice(index, 1)
    },
    removeAgreementSla (index) {
      this.item.agreementSlas.splice(index, 1)
    },
    addAgreementConsent () {
      let item = {
        consent: null
      }
      this.item.agreementConsents.push(item)
    },
    addAgreementDevice () {
      let item = {
        device: null,
        isDeviceAddressBasedOnAgreement: 1
      }
      this.item.agreementDevices.push(item)
    },
    addAgreementSla () {
      let item = {
        sla: null
      }
      this.item.agreementSlas.push(item)
    },
    getContactPersons () {
      if (this.item.company) {
        const IS_CONTACT_PERSON = 1
        let params = {
          'state': 1,
          'firm': this.getIdLink(this.item.company),
          'isContactPerson': IS_CONTACT_PERSON,
          'pagination': false
        }
        let link = addParamsToQuery('user_data_employees', params)
        this.fetchUserDataEmployees(link)
      }
    },
    async getConsents () {
      if (this.item.agreementType && (this.routeName === 'EXCMAgreementCreate' || this.openedInCreateModal)) {
        let params = {
          'state': 1,
          'agreementType': this.getIdLink(this.item.agreementType),
          'pagination': false
        }
        this.consentsOptions = []
        this.item.agreementConsents = []
        const response = await new ApiService('e_x_c_m_consents', params).getResults()
        let responseData = response.items
        for (let i in responseData) {
          let object = {
            consent: responseData[i]['@id'],
            agree: 0
          }
          this.item.agreementConsents.push(object)
        }
        this.consentsOptions = responseData
      }
    },
    getEXCMAgreementTypes () {
      let params = {
        'state': 1,
        'pagination': false
      }
      let link = addParamsToQuery('e_x_c_m_agreement_types', params)
      this.fetchAgreementTypes(link)
    },
    getEXCMTaskTypes () {
      let params = {
        'state': 1,
        'pagination': false
      }
      let link = addParamsToQuery('e_x_c_m_task_types', params)
      this.fetchTaskTypes(link)
    },
    getCaseTypes () {
      let params = {
        'state': 1,
        'pagination': false
      }
      let link = addParamsToQuery('e_x_c_m_case_types', params)
      this.fetchCaseTypes(link)
    },
    async getCaseGenres () {
      let params = {
        'state': 1,
        'pagination': false
      }
      const response = await new ApiService('e_x_c_m_case_genres', params).getResults()
      this.caseGenresOptions = response.items
    },
    getDevices () {
      let params = {
        'pagination': false
      }
      let link = addParamsToQuery('e_x_c_m_devices', params)
      this.fetchDevices(link)
    },
    getSlas () {
      let params = {
        'pagination': false
      }
      let link = addParamsToQuery('e_x_c_m_slas', params)
      this.fetchSlas(link)
    },
    async getCompanies () {
      this.companyOptions = []
      let params = {
        isCompany: 1,
        pagination: false,
        state: 1
      }
      const response = await new ApiService('user_datas', params).getResults()
      this.companyOptions = response.items
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
